import { UNASSIGNED } from "./constants";
import {
  compareAgentLabels,
  compareCommissionContracts,
} from "../sortHelpers";

export const plural = (n, w) => `${n} ${w}${n === 1 ? "" : "s"}`;

// Group contracts by agent name; unassigned always sorts last.
// Contracts within each group are sorted by signedDate, providerNumber, and number.
export function groupByAgent(contracts) {
  const map = new Map();
  for (const c of contracts) {
    const key = c.agent
      ? `${c.agent.firstName} ${c.agent.lastName}`
      : UNASSIGNED;
    if (!map.has(key)) map.set(key, []);
    map.get(key).push(c);
  }

  for (const list of map.values()) {
    list.sort(compareContracts);
  }

  return [...map.entries()].sort(([a], [b]) => {
    return compareAgentLabels(a, b, { lastLabel: UNASSIGNED });
  });
}

function compareContracts(a, b) {
  return compareCommissionContracts(a, b, {
    signed: (contract) => contract.signed ?? contract.signed,
    providerNumber: (contract) =>
      contract.providerNumber ?? contract.providernumber,
    contractNumber: (contract) => contract.number,
  });
}
